import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: 'Dashboard',          to: '/dashboard',         icon: 'fa fa-th-large',            adminOnly: false },
  { label: 'Patients',           to: '/patients',          icon: 'fa fa-user-injured',         adminOnly: false },
  { label: 'Common Diet',        to: '/admin/diets',       icon: 'fa fa-apple-alt',            adminOnly: false },
  { label: 'Hospital Info',      to: '/admin/hospital',    icon: 'fa fa-hospital-alt',         adminOnly: false },
  { label: 'Staff',              to: '/admin/staff',       icon: 'fa fa-id-card',              adminOnly: true  },
  { label: 'Attendance',         to: '/admin/attendance',  icon: 'fa fa-calendar-check',       adminOnly: true  },
  { label: 'Billing',            to: '/admin/billing',     icon: 'fa fa-file-invoice-dollar',  adminOnly: true  },
  { label: 'Treatments',         to: '/admin/treatments',  icon: 'fa fa-stethoscope',          adminOnly: true,  isConfig: true },
  { label: 'Designations',       to: '/admin/designations',icon: 'fa fa-id-badge',             adminOnly: true,  isConfig: true },
  { label: 'Accounts',           to: '/admin/accounts',    icon: 'fa fa-wallet',               adminOnly: true  },
  { label: 'Account Categories', to: '/admin/categories',  icon: 'fa fa-tags',                 adminOnly: true,  isConfig: true },
  { label: 'Trash',              to: '/admin/trash',       icon: 'fa fa-trash',                adminOnly: true  },
  { label: 'Users',              to: '/admin/users',       icon: 'fa fa-users-cog',            adminOnly: true  },
];

export default function Sidebar() {
  const { user } = useSelector(state => state.authState);
  const isAdminOrManager = user?.role === 'admin' || user?.role === 'manager' || user?.role === 'master';
  const location = useLocation();

  const isCurrentlyConfig = navItems.filter(i => i.isConfig).some(i => location.pathname === i.to);
  const [isConfigOpen, setIsConfigOpen] = useState(isCurrentlyConfig);

  const isActive = (path) => location.pathname === path;
  const visibleItems = navItems.filter(item => !item.adminOnly || isAdminOrManager);

  return (
    <div className="sidebar-wrapper">
      {/* ── Mobile Horizontal Scroll Nav (Visible on Mobile only) ── */}
      <div className="mobile-horizontal-nav d-md-none">
        {visibleItems.map(item => (
          <Link
            key={item.to}
            to={item.to}
            className={`mobile-nav-pill ${isActive(item.to) ? 'active' : ''}`}
          >
            <i className={item.icon}></i>
            <span>{item.label}</span>
          </Link>
        ))}
      </div>

      {/* ── Desktop Vertical Sidebar (Visible on Desktop only) ── */}
      <nav id="sidebar" className="d-none d-md-block">
        <div className="sidebar-logo p-3 text-center border-bottom border-secondary mb-3">
          <img
            src="/images/logo-light.jpg"
            alt="Green Naturopathy"
            style={{ width: '100%', maxWidth: '180px', borderRadius: '8px' }}
          />
        </div>

        <ul className="list-unstyled components">
          <li className="nav-section-label">Navigation</li>
          {visibleItems.filter(item => !item.isConfig).map(item => (
            <li key={item.to}>
              <Link to={item.to} className={isActive(item.to) ? 'active' : ''}>
                <i className={item.icon}></i>
                {item.label}
              </Link>
            </li>
          ))}

          {visibleItems.some(item => item.isConfig) && (
            <>
              <li className="nav-section-label" style={{ marginTop: '1rem' }}>Configuration</li>
              <li className="sidebar-dropdown">
                <a
                  href="#!"
                  onClick={(e) => { e.preventDefault(); setIsConfigOpen(!isConfigOpen); }}
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.8rem 1.25rem', color: '#cbd5e1', textDecoration: 'none' }}
                >
                  <div><i className="fa fa-cogs" style={{ width: '24px' }}></i> Settings</div>
                  <i className={`fa fa-chevron-${isConfigOpen ? 'up' : 'down'}`} style={{ fontSize: '0.7rem' }}></i>
                </a>
                <ul className={`collapse list-unstyled ${isConfigOpen ? 'show' : ''}`}>
                  {visibleItems.filter(item => item.isConfig).map(item => (
                    <li key={item.to}>
                      <Link to={item.to} className={isActive(item.to) ? 'active' : ''} style={{ paddingLeft: '2.5rem' }}>
                        <i className={item.icon}></i>
                        {item.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
            </>
          )}
        </ul>

        {/* User info at bottom */}
        <div style={{
          position: 'absolute', bottom: 0, left: 0, right: 0,
          padding: '0.75rem 1.25rem',
          borderTop: '1px solid rgba(255,255,255,0.06)',
          display: 'flex', alignItems: 'center', gap: '0.6rem',
          background: 'var(--sidebar-bg)'
        }}>
          <div style={{ width: 30, height: 30, background: 'rgba(13,148,136,0.2)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <i className="fa fa-user" style={{ fontSize: '0.7rem', color: '#5eead4' }}></i>
          </div>
          <div style={{ lineHeight: 1.3, overflow: 'hidden' }}>
            <div style={{ fontSize: '0.78rem', fontWeight: 600, color: '#e2e8f0', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{user?.name || 'User'}</div>
            <div style={{ fontSize: '0.68rem', color: '#64748b', textTransform: 'capitalize' }}>{user?.role}</div>
          </div>
        </div>
      </nav>
    </div>
  );
}
